export default "__VITE_ASSET__B7gBDk58__"